module.exports = __webpack_public_path__ + "img/vac-pan.b1787df9.png";